import { phonesign } from '@/utils/tool';
export const columns = [
  {
    title: '姓名',
    dataIndex: 'name',
    slots: { customRender: 'name' },
  },
  {
    title: '号码',
    dataIndex: 'phone_number',
    customRender: (text) => {
      return phonesign(text);
    },
  },
  {
    title: '企业名称',
    dataIndex: 'cus_company',
  },
  {
    title: '注册日期',
    dataIndex: 'create_time',
  },
];
